var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.iconComponent)?_c(_vm.iconComponent,{tag:"component",staticClass:"suaw-icon",class:['suaw-icon--' + _vm.color, 'suaw-icon--' + _vm.size, _vm.className],style:(_vm.pixelSize ? { '--comp-icon-size': `${_vm.pixelSize}px` } : {})}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }